import Relative from '../../../Relative/Relative';
import Row from '../../../Row/Row';
import SVG from '../../../SVG/SVG';

import checkIcon from './graphics/check.svg?raw';
import couponIcon from './graphics/coupon.svg?raw';
import invalidIcon from './graphics/invalid.svg?raw';

import styles from './CouponDialogIcon.module.css';

export type IconStatus = 'default' | 'applied' | 'invalid';

type CouponDialogIconProps = {
    status: IconStatus;
};

const CouponDialogIcon = ({ status }: CouponDialogIconProps) => {
    return (
        <Row horizontal="center">
            <Relative>
                <SVG
                    src={couponIcon}
                    fillWithCurrentColor
                    className={styles.CouponIcon}
                />

                {status === 'applied' && (
                    <SVG src={checkIcon} className={styles.StatusIcon} />
                )}

                {status === 'invalid' && (
                    <SVG src={invalidIcon} className={styles.StatusIcon} />
                )}
            </Relative>
        </Row>
    );
};

export default CouponDialogIcon;
